module.exports = __webpack_public_path__ + "img/ball_7_black.a13eea38.png";